import { Controller } from "@hotwired/stimulus"

// Workplace empty-state illustrations (TMS-1221): play once on first paint,
// then sit on the last frame until hover/focus plays the clip again. The clip
// is either a Lottie JSON drawn into the canvas target or an exported <video>.
export default class extends Controller {
  static targets = ["canvas", "video"]
  static values = { animationUrl: String }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    if (this.hasVideoTarget) {
      this.playVideo()
      return
    }
    if (!this.hasCanvasTarget || !this.animationUrlValue) return

    this.loadAnimation()
  }

  disconnect() {
    this.animation?.destroy()
    this.animation = null
  }

  replay() {
    if (this.hasVideoTarget) {
      this.videoTarget.currentTime = 0
      this.playVideo()
      return
    }
    if (!this.animation) return

    this.animation.goToAndPlay(0)
  }

  playVideo() {
    // Autoplay can be refused (power saving, data saver); the poster is the
    // last frame, so a refused play still shows the finished illustration.
    this.videoTarget.play().catch(() => {})
  }

  async loadAnimation() {
    const lottie = (await import("lottie-web/build/player/lottie_light")).default
    if (this.animation === null) return

    this.animation = lottie.loadAnimation({
      container: this.canvasTarget,
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: this.animationUrlValue
    })
    this.animation.addEventListener("DOMLoaded", () => {
      this.element.classList.add("has-animation")
    })
  }
}
